import React, { useState } from "react";
import "./Faq.css";
import { FiPlus, FiMinus, FiSearch } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const Faq = () => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const faqData = t("faq.items", { returnObjects: true });

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const filteredData = Array.isArray(faqData)
    ? faqData.filter(
        (item) =>
          item.question &&
          item.question.toLowerCase().includes(searchTerm.toLowerCase()),
      )
    : [];

  return (
    <div className="faq-container">
      <div className="faq-header">
        <h2>{t("faq.title")}</h2>
        <p>{t("faq.subtitle")}</p>
      </div>

      {/* Barre de recherche */}
      <div className="faq-search-wrapper">
        <FiSearch className="search-icon" />
        <input
          type="text"
          placeholder={t("faq.search_placeholder")}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="faq-list">
        {filteredData.map((item, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
            onClick={() => toggleAccordion(index)}
          >
            <div className="faq-question">
              <div className="faq-text-content">
                <span className="faq-category">{item.category}</span>
                <h3>{item.question}</h3>
              </div>
              <span className="faq-icon">
                {activeIndex === index ? <FiMinus /> : <FiPlus />}
              </span>
            </div>

            <div
              className={`faq-answer ${activeIndex === index ? "open" : ""}`}
            >
              <div className="answer-content">
                <p>{item.answer}</p>
              </div>
            </div>
          </div>
        ))}

        {/* Petit message si aucun résultat trouvé */}
        {filteredData.length === 0 && (
          <p style={{ textAlign: "center", color: "#aaa", marginTop: "20px" }}>
            Aucun résultat trouvé pour "{searchTerm}"
          </p>
        )}
      </div>
    </div>
  );
};

export default Faq;
